import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { datosPersonales } from '../models/paciente.model';



@Injectable()
export class PacientesService {

    public listaUrl: string;
    private httpClient: any;
    public insertUrl: string;
    public consultaUrl: string;
    public pacientebasico: datosPersonales[];
    public paciente;


    // ### DEVEL ###
    // TODO: Cambiar url
    // private url = 'http://gestorpacientes.devel.itsolutionsspa.cl:8000/api/v1/';
    private url = '/api/v1/'
    // private url = 'http://gpacientes.itsolutionsspa.cl/api/v1/'
    //private url = 'http://gestorpacientes.devel.itsolutionsspa.cl/api/v1/';

    constructor(
        public _httpClient: HttpClient,

    ) {
        this.httpClient = _httpClient;
        this.listaUrl = this.url + 'patient/list/';
        this.insertUrl = this.url + 'consultation/';
        this.consultaUrl = this.url + 'patient/';

    }
    getPacientes(): Observable<any> {
        return this.httpClient.post(this.listaUrl);
    }

    getPaciente(id): Observable<any> {
        return this._httpClient.get(this.consultaUrl + id);

    }

    addPaciente(paciente) {

        // El backend recogerá un parametro json
        const params = paciente;
        // Establecemos cabeceras
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        return this._httpClient.post(this.insertUrl, params, {headers});
    }
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl
 ********************************************************************************************************************/
